"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageUpload = require("./ImageUpload");

var _ImageUpload2 = _interopRequireDefault(_ImageUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ProfileImageUpload",

  props: ["user", "editing", "profilePictureUrl"],

  components: {
    ImageUpload: _ImageUpload2.default
  },

  data: function data() {
    return {
      src: this.user.profile_picture
    };
  },
  mounted: function mounted() {
    document.body.append(document.querySelector(".g-core-image-corp-container"));
  },


  methods: {
    imageUploaded: function imageUploaded(res) {
      window.location.reload();
    },
    errorHandler: function errorHandler(error) {
      // Expecting only large file errors.
      this.$toastr.error(this.$t("common.messages.large_image_error"));
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/ProfileImageUpload.vue
// module id = t98U
// module chunks = 0 1